module.exports = __webpack_public_path__ + "07d96060a2c580ce9964ac271e8f54cd.jpg";